
//---- components ---------
//---- mixins -------------
import DSCommonJS from "@/app/components/callcenter/service-sessions/ds-common.js";
//---- services -----------
import ProjectHomeService from '@/app/services/projectHome.service.js';
//---- 3rd-parties --------
import { BIconJustify } from "bootstrap-vue";

export default {
  mixins: [DSCommonJS],
  components: {
    BIconJustify
  },
  computed: {
    // returns current profile data (along with quests)
    currentProfileData() {
      return this.$store.getters["projectData/currentProfile"];
    },
    notOnProjectSelectionPage() {
      return this.$route.path !== "/project-selection";
    },
    standalone() {
      return this.mode === "standalone";
    },
    currentQuestId() {
      return this.$store.getters["projectData/currentQuest"].id
    },
    menu() {
      const menu = [];

      for (let quest of this.currentProfileData?.quests || []) {
        if (!quest?.properties?.MENU) {
          menu.push(quest);
          continue;
        }

        // check if the menu already exists
        const subMenu = menu.find(
          (q) => q.type == "menu" && q.caption === quest.properties.MENU
        );
        if (subMenu) {
          subMenu.quests.push(quest);
        } else {
          menu.push({
            caption: quest.properties.MENU,
            id: quest.properties.MENU,
            type: "menu",
            quests: [quest],
          });
        }
      }

      return menu;
    },
    hasQuests() {
      return this.currentProfileData?.quests?.length > 1;
    },
  },
  methods: {
    async changeQuest(quest) {

      if (!await this.checkForUnsavedAuthoringModifications())
        return;

      // if the quest is a submenu, just open it
      if (quest.type == 'menu') {
        return;
      }
      const response = await ProjectHomeService.switchQuest(quest.id)
      if (response.data.status == "success") {
        if (response.data.isServiceSession == "true") {
          this.gotoDSDashBoard()
        }
        else {
          // this push is needed to clear the hash in url
          if (this.$route.path != "/project-home" || !!this.$route.hash)
            this.safeRouterPush("/project-home");
        }
        this.$store.dispatch("projectData/setCurrentQuest", quest);
      }
    },

    async gotoDSDashBoard() {
      //clear the tabs
      this.clearTabs();
      // clear the opened ds from tab
      this.clearOpenedDSFromTab();
      // set current page to 1
      this.setDefaultPage();
      // clear sort filter
      this.clearSortfilter();
      // clear the sessions data
      this.clearSessionsData();

      // init the ds dashboard data
      await this.$store.dispatch("dsDashboard/getDSDashboard");
      // set the "DS_DASHBOARD" view
      this.setCurrentTemplateView("DS_DASHBOARD");
      // clear the filter value
      this.clearSearchFilterValue();
      this.$store.getters["projectData/currentQuest"].name = "SERVICE_SESSIONS";
      if (this.$route.path !== "/ds/dashboard")
        this.pushWithAnchor({
          path: "/ds/dashboard",
          hash: this.updateHash("DASHBOARD")
        });
      else
        this.safeRouterPush({
          hash: this.updateHash("DASHBOARD")
        });
    }, // end gotoDSDashBoard()

    isActive(quest) {
      if (this.$route.path.startsWith('/ds'))
        return quest.name == "SERVICE_SESSIONS";

      if (quest.type != 'menu')
        return quest.id == this.currentQuestId;

      var test = !!quest.quests.find(q => q.id == this.currentQuestId);
      return test;
    }, // end isActive()

    // return styles applying to font
    fontStyle(quest) {
      const props = quest.properties;
      if (!props)
        return "";

      let style = "";

      const bgColor = props['BG-COLOR'];
      if (bgColor)
        style += "background-color: " + bgColor + "; ";

      const fontStyle = props['FONT-STYLE'];
      if (fontStyle)
        style += "font-style: " + fontStyle + "; ";

      const fontWeight = props['FONT-WEIGHT'];
      if (fontWeight)
        style += "font-weight: " + fontWeight + "; ";

      const color = props['COLOR'];
      if (color)
        style += "color: " + color + "; ";

      return style;
    }, // end fontStyle()

    // icon(quest) {
    //   return this.findProperty(quest.properties, "ICON");
    // }, // end icon()
    // 
    // findProperty(props, named) {
    //   return props.find((p) => p.name == named)?.value;
    // }, // end findProperty()

  } // end methods
}